<template>
  <section class="page">
    <b-container>
      <b-row>
        <h2>Selbst forschen</h2>
      </b-row>
      <b-row>
        <div
          class="col-sm-12 col-md-12 col-lg-6 story filter-sentence-container "
        >
          <div class="filter-sentence ">
            <p>
              Zeige mir für <br />
              <select
                class="select-dropdown"
                v-model="currentVisualisation.applicableLaws"
                name="applicableLaws"
              >
                <option :value="null">alle OZG-Leistungen,</option>
                <option :value="[6]"
                  >die Top 100 Leistungen Bürger*innen 👍,</option
                >
                <option :value="[8]"
                  >die Top 100 Leistungen Unternehmen 📈,</option
                >
                <option :value="[2]">die Top 100 Leistungen 115 📞,</option>
              </select>
              <select
                class="select-dropdown"
                v-model="currentVisualisation.referenceImplementation"
                name="referenceImplementation"
              >
                <option :value="null">alle Termine</option>
                <option :value="true"
                  >Termine von Referenzimplementierung</option
                >
                <option :value="false"
                  >Termine von nicht-Referenzimplementierungen</option
                >
              </select>
              <select
                class="select-dropdown"
                v-model="currentVisualisation.implementationStatus"
                name="implementationStatus"
              >
                <option :value="null">in allen Phasen</option>
                <option value="PLANNING">in der Planungsphase</option>
                <option value="DESIGN">in der Konzeptionsphase</option>
                <option value="IMPLEMENTATION">in der Umsetzungsphase</option>
                <option value="DONE">zur Fertigstellung</option> </select
              ><br />
              <select
                class="select-dropdown"
                v-model="currentVisualisation.chartType"
                name="chartType"
              >
                <option value="activity-map">als Aktivitäskarte.</option>
                <option value="heatmap">als Heatmap.</option>
                <option value="list">als Terminliste.</option>
                <option value="service-list">als Serviceliste.</option>
              </select>
            </p>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 visual">
          <OZGActivityHeatmap
            v-if="currentVisualisation.chartType === 'activity-map'"
            :statusType="currentVisualisation.implementationStatus"
            :applicableLaws="currentVisualisation.applicableLaws"
            :referenceImplementation="
              currentVisualisation.referenceImplementation
            "
            showLegend="false"
          ></OZGActivityHeatmap>
          <OZGActivityServiceList
            v-if="currentVisualisation.chartType === 'service-list'"
            :statusType="currentVisualisation.implementationStatus"
            :applicableLaws="currentVisualisation.applicableLaws"
            :referenceImplementation="
              currentVisualisation.referenceImplementation
            "
          ></OZGActivityServiceList>

          <OZGActivityCountyMap
            v-if="currentVisualisation.chartType === 'heatmap'"
            :statusType="currentVisualisation.implementationStatus"
            :applicableLaws="currentVisualisation.applicableLaws"
            :referenceImplementation="
              currentVisualisation.referenceImplementation
            "
          ></OZGActivityCountyMap>
          <OZGActivityList
            v-if="currentVisualisation.chartType === 'list'"
            :statusType="currentVisualisation.implementationStatus"
            :applicableLaws="currentVisualisation.applicableLaws"
            :referenceImplementation="
              currentVisualisation.referenceImplementation
            "
          ></OZGActivityList>
        </div>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import OZGActivityHeatmap from "../visualisations/OZGActivityHeatmap";
import OZGActivityServiceList from "../visualisations/OZGActivityServiceList";
import OZGActivityCountyMap from "../visualisations/OZGActivityCountyMap";
import OZGActivityList from "../visualisations/OZGActivityList";
export default {
  name: "OZGTimelineStatusExplorer",
  data: function() {
    return {
      currentVisualisation: {
        referenceImplementation: null,
        implementationStatus: null,
        applicableLaws: null,
        states: null,
        chartType: "activity-map"
      }
    };
  },
  components: {
    OZGActivityServiceList,
    OZGActivityHeatmap,
    OZGActivityCountyMap,
    OZGActivityList
  }
};
</script>

<style scoped lang="scss">
.filter-sentence-container {
}
.filter-sentence {
  margin-top: 2vh;
}
.loading-anim {
  margin-top: 8vh;
}

.filter-sentence .select-dropdown {
  background-color: #fff;
  background-image: none;
  padding: 6px;
  font-size: 1.5rem;
  line-height: 2rem;

  @media (max-width: 576px) {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  text-align: center;
  font-family: "Open Sans Condensed", sans-serif;
  font-weight: 700;
  font-style: normal;
  margin-bottom: 10px;
  border-radius: 1px;
  outline: 2px inset black;
  outline-offset: -2px;
}

.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #000;
}
.select-css:focus {
  border-color: #000;
  box-shadow: none;
  color: #222;
  outline: none;
}
.chart {
  @media (min-width: 992px) {
    margin-top: -70px;
  }
}

.visual {
}
</style>
